import { configRefs } from '@utils/constants';

function buildUrl(url, options) {
  return (options == null ? void 0 : options.previewMode) ? `${configRefs.apis.pm2.preview.dangerouslyAssertSyncValue()}${url}` : `${configRefs.apis.pm2.url.dangerouslyAssertSyncValue()}${url}`;
}

export { buildUrl };
//# sourceMappingURL=util.build-url.js.map
